export default __webpack_public_path__ + "static/media/placeholder.d5d59ae1.svg";